import { Link } from 'react-router-dom';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

/**
 * A plain table for back-office lists.
 * columns: [{ label, render(row), className }]. className applies to the head and the cell,
 * so `hidden md:table-cell` hides a secondary column on phones.
 */
export default function DataTable({ columns, rows }) {
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-card">
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((c) => (
              <TableHead key={c.label} className={c.className}>
                {c.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.Id}>
              {columns.map((c) => (
                <TableCell key={c.label} className={c.className}>
                  {c.render(row)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

/** The first cell of a row: a link to the record and an optional second line. */
export function RowLink({ to, children, mono = false, sub }) {
  return (
    <>
      <Link to={to} className={cn('font-medium text-primary hover:underline', mono && 'font-mono')}>
        {children}
      </Link>
      {sub && <p className="text-xs text-muted-foreground">{sub}</p>}
    </>
  );
}

export function Dash() {
  return <span className="text-muted-foreground">—</span>;
}
